import {
  ClarityIcons,
  angleDoubleIcon,
  arrowIcon,
  banIcon,
  chatBubbleIcon,
  checkIcon,
  circleIcon,
  clockIcon,
  codeIcon,
  cogIcon,
  copyIcon,
  devicesIcon,
  errorStandardIcon,
  exclamationCircleIcon,
  exclamationTriangleIcon,
  eyeHideIcon,
  eyeIcon,
  filterGridIcon,
  gridChartIcon,
  happyFaceIcon,
  infoCircleIcon,
  infoStandardIcon,
  linkIcon,
  lineChartIcon,
  lockIcon,
  logoutIcon,
  minusCircleIcon,
  pencilIcon,
  playIcon,
  plusCircleIcon,
  plusIcon,
  refreshIcon,
  resizeIcon,
  searchIcon,
  shrinkIcon,
  stopIcon,
  tableIcon,
  timesIcon,
  timesCircleIcon,
  trashIcon,
  twoWayArrowsIcon,
  volumeMuteIcon,
  volumeUpIcon,
  wrenchIcon,
  contractIcon
} from '@cds/core/icon';
import '@cds/core/icon/register.js';

ClarityIcons.addIcons(
  arrowIcon,
  angleDoubleIcon,
  banIcon,
  chatBubbleIcon,
  checkIcon,
  circleIcon,
  clockIcon,
  codeIcon,
  cogIcon,
  copyIcon,
  devicesIcon,
  errorStandardIcon,
  exclamationCircleIcon,
  exclamationTriangleIcon,
  eyeHideIcon,
  eyeIcon,
  filterGridIcon,
  gridChartIcon,
  happyFaceIcon,
  infoCircleIcon,
  infoStandardIcon,
  lineChartIcon,
  linkIcon,
  lockIcon,
  logoutIcon,
  minusCircleIcon,
  pencilIcon,
  playIcon,
  plusCircleIcon,
  plusIcon,
  refreshIcon,
  resizeIcon,
  searchIcon,
  shrinkIcon,
  stopIcon,
  tableIcon,
  timesIcon,
  timesCircleIcon,
  trashIcon,
  twoWayArrowsIcon,
  volumeMuteIcon,
  volumeUpIcon,
  wrenchIcon,
  contractIcon
);
